var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-drawer',{attrs:{"visible":_vm.visible,"size":"420px","with-header":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"rich-content-wrapper"},[_c('div',{staticClass:"frame"},[_c('rich-content',{staticClass:"non-selection",attrs:{"rich-text":_vm.htmlContent}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }